import React from "react";

import img1 from "../img/Corazon Delator II&&Lo que se da no se quita---Adobe Photoshop interweaving of textured layers over AI-generated and curated images___2025-02[[13]].jpg"

export default function Machine_3_2() {
  return (
    <div className="panel-block">

      <div className="panel-container-left">
        <img
          loading="lazy"
          src={img1}
          alt="3.2 · LOVE LETTERS TO NO ONE"
        />
      </div>

      <div className="panel-container-right">
        <h2>3.2 · LOVE LETTERS TO NO ONE</h2>

      <p>
    Not addressed.<br />
    Not returned.
  </p>

  <p>
    Letters written from the Plane of Cycles<br />
    to what cannot answer.
  </p>

  <p>
    They were not filed under doctrine.<br />
    They were filed under persistence.
  </p>

  <p>
    Even silence<br />
    belongs to the Machine.
  </p>

  <p><a  target="_blank"  rel="noreferrer"  href="https://thevakztharimachine.substack.com/s/love-letters-to-no-one">Read it here</a></p>
   
  
      </div>

    </div>
  );
}
